/** Who is signed in to transit, as TransitLayout loaded it from GET /me. */
import { createContext, useContext } from 'react'
import type { Org, TransitUser } from '../../types/transit'

export interface TransitSession {
  user: TransitUser
  org: Org
}

export const TransitSessionContext = createContext<TransitSession | null>(null)

export function useTransitSession(): TransitSession {
  const s = useContext(TransitSessionContext)
  if (!s) throw new Error('useTransitSession outside TransitLayout')
  return s
}
